import { render, staticRenderFns } from "./paysetting.vue?vue&type=template&id=57a528be&"
import script from "./paysetting.vue?vue&type=script&lang=js&"
export * from "./paysetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports